import { Viewer } from "@toast-ui/react-editor";
import { NoticeDto } from "apis/data-contracts";
import { LeftIcon } from "assets/icons";
import Board from "components/Common/Board/Board";
import MobilePageCover from "components/Common/MobilePageCover/MobilePageCover";
import Button from "components/foundation/Button";
import Divider from "components/foundation/Divider";
import Input from "components/foundation/Input/Input";
import Modal from "components/foundation/Modal/Modal";
import { ROUTER_PATH } from "config/path";
import useNoticeDeleteMutation from "features/notice/hooks/mutations/useNoticeDeleteMutation";
import useUserDetailQuery from "features/user/hooks/queries/useUserDetailQuery";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import addHttpsToAnchorTag from "utils/addHttpsToAnchorTag";

interface NoticeDashboardDetailPageProps {
  noticeDetail: NoticeDto;
}

const NoticeDashboardDetailMobilePage = ({
  noticeDetail,
}: NoticeDashboardDetailPageProps) => {
  const navigate = useNavigate();
  const { mutate: deleteMutate } = useNoticeDeleteMutation();

  const handleDeleteNotice = () => {
    //삭제 API
    deleteMutate(noticeDetail.uuid, {
      onSuccess: () => {
        navigate(ROUTER_PATH.notice.dashboard._path);
      },
    });
  };

  const handleEditClick = () => {
    navigate(ROUTER_PATH.notice.dashboard.edit(noticeDetail.uuid));
  };

  const { data: userData } = useUserDetailQuery();
  const isMine = userData?.uuid === noticeDetail.createdUser.uuid;

  return (
    <MobilePageCover
      header={
        <Link to={ROUTER_PATH.notice.dashboard._path}>
          <LeftIcon />
        </Link>
      }
    >
      <NoticeDashboardDetailMobilePageBoard>
        <div>
          <h2>{noticeDetail.title}</h2>
        </div>
        <Divider />
        <Viewer initialValue={addHttpsToAnchorTag(noticeDetail.content)} />
        <Divider />
        <AttachmentLayout>
          <h3>첨부파일</h3>
          <div>
            <Input
              onClick={() => {
                noticeDetail.noticeAttachmentFileList[0]?.fileUrl &&
                  window.open(noticeDetail.noticeAttachmentFileList[0].fileUrl);
              }}
              disabled={!noticeDetail.noticeAttachmentFileList[0]?.fileName}
              value={
                noticeDetail.noticeAttachmentFileList[0]?.fileName ??
                "첨부된 파일 없음"
              }
              readOnly
              onFocus={(e) => e.target.blur()}
              style={{
                width: "100%",
              }}
            />
          </div>
        </AttachmentLayout>
        {isMine && (
          <ButtonsLayout>
            <Modal.Root>
              <Modal.Trigger asChild>
                <Button variant="tertiary-neg" size="medium">
                  삭제
                </Button>
              </Modal.Trigger>
              <Modal.Body
                title="정말 삭제하시겠습니까?"
                onCancel
                onConfirm={handleDeleteNotice}
              />
            </Modal.Root>
            {noticeDetail.isMobile && (
              <Button variant="primary" size="medium" onClick={handleEditClick}>
                수정
              </Button>
            )}
          </ButtonsLayout>
        )}
      </NoticeDashboardDetailMobilePageBoard>
    </MobilePageCover>
  );
};

export default NoticeDashboardDetailMobilePage;

const NoticeDashboardDetailMobilePageBoard = styled(Board)`
  padding: 2rem 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  h2 {
    ${({ theme }) => theme.typography.sub1.semibold};
  }
`;

const AttachmentLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;

  h3 {
    ${({ theme }) => theme.typography.body3.medium};
  }
`;

const ButtonsLayout = styled.div`
  display: flex;
  gap: 1rem;

  > button {
    flex: 1;
  }
`;
